import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Button from '../../UI/Button';
import Grid from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import UsuarioFindDialog from '../../Usuario/UsuarioFindDialog';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import { Link } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import AbaMenu from './AbaMenu';
import TextFieldUsuario from '../../Usuario/UI/TextFieldUsuario';

const useStyles = makeStyles({
    paper: {
        display: 'flex',
        flexDirection: 'column',
    },
    submit: {
        // margin: theme.spacing(3, 0, 3),
        textTransform: 'none',
    },
    buscarBtn: {
        // margin: theme.spacing(3, 3, 3),
        textTransform: 'none',
    },
    closeIcon: {
        marginTop: '20px',
        marginBottom: '20px',
        cursor: 'pointer'
    },
    menuIcon: {
        marginTop: '15px',
        marginBottom: '20px',
        cursor: 'pointer'
    },
    divAlunoFoto: {
        marginTop: '20px',
        marginBottom: '20px'
    },
    gridAbaMenu: {
        display: 'flex',
        justifyContent: 'space-around'
    }
});

const AlunoForm = ({
    aluno,
    setAluno,
    clickSubmit,
    handleDelete,
    handleDeleteUsuario,
}) => {
    const classes = useStyles();
    const [openSearchUsuario, setOpenSearchUsuario] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleSelectedUsuario = (userAdding) => {
        setAluno({
            ...aluno,
            usuarioAluno: userAdding
        });
        setOpenSearchUsuario(false);
    }

    const closeUsuarioSearch = () => {
        setOpenSearchUsuario(false);
    }

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleAlunoLivro = () => {
        handleMenuClose();
    }

    const handleChange = (event) => {
        setAluno({
            ...aluno,
            [event.target.name]: event.target.value
        })
    }

    const handleBuscarUsuario = () => {
        setOpenSearchUsuario(true);
    }





    return (
        <>
            <UsuarioFindDialog
                openSearchUsuario={openSearchUsuario}
                handleSelectedUsuario={handleSelectedUsuario}
                closeUsuarioSearch={closeUsuarioSearch}
            />
            <Container className={classes.paper} component={Paper} >
                <Grid container justifyContent="space-between">
                    <Grid size={3}>
                        <CloseIcon
                            onClick={() => setAluno(null)}
                            className={classes.closeIcon}
                            fontSize='small'
                        />
                    </Grid>
                    <Grid style={{ flexBasis: '5%' }} size={3}>
                        <MenuIcon
                            className={classes.menuIcon}
                            onClick={(event) => handleMenuClick(event)}
                            color="secondary"
                            fontSize='small'
                        />
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                        >
                            <MenuItem
                                component={Link}
                                to={{
                                    pathname: '/aluno-livro',
                                }}
                                state={{
                                    aluno: aluno
                                }}
                                onClick={() => handleAlunoLivro()}
                            >
                                Aluno Livro
                            </MenuItem>
                        </Menu>
                    </Grid>

                </Grid>

                <Typography variant="h6">
                    Cadastro Aluno
                </Typography>
                <Grid>
                    <form onSubmit={clickSubmit}>
                        <div style={{
                            display: 'flex',

                        }}>
                            <TextField
                                variant="outlined"
                                size="small"
                                margin="normal"
                                label="Código"
                                name="codAlunoEscola"
                                autoFocus
                                onChange={handleChange}
                                value={aluno && aluno.codAlunoEscola ? aluno.codAlunoEscola : ''}
                            />
                            <TextField
                                style={{
                                    marginLeft: '8px'
                                }}
                                size="small"
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                required
                                label="Nome"
                                name="nome"
                                onChange={handleChange}
                                value={aluno && aluno.nome ? aluno.nome : ''}
                                slotProps={{
                                    htmlInput: { maxLength: 60 }
                                }}
                            />
                        </div>
                        <TextFieldUsuario
                            label='Usuário Aluno'
                            value={aluno && aluno.usuarioAluno ? aluno.usuarioAluno.email : ''}
                            handleBuscarUsuario={handleBuscarUsuario}
                            handleDeleteUsuario={handleDeleteUsuario}
                        />

                        <Grid container direction='row' spacing={3}>
                            <Grid>
                                <Button
                                    type="submit"
                                >
                                    Salvar
                                </Button>
                            </Grid>
                            <Grid>
                                <Button
                                    onClick={handleDelete}
                                >
                                    Remover
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                    <AbaMenu
                        aluno={aluno}
                    />
                </Grid>
            </Container>
        </ >
    );
}

export default AlunoForm;